<template>

    <div class="card">
        <div class="card-header border-bottom">
            <i class="fas fa-language me-2"></i>{{ TR.terms }}
        </div>
        <div class="card-body container1 p-4">

            <!-- <div v-if="G.userHavePermission('add')" class="row mb-3"> -->
            <div v-if="G.isSysAdmin()" class="row mb-3">
                <div class="col-12 col-sm-8 offset-sm-2">

                    <fieldset class="p-3 mb-3 text-primary border-bottom border-primary border-2">
                        <legend class="fw-bold mb-3">{{ TR.add }}</legend>
                        <div class="row my-3">
                            <div class="col-12 col-sm-4 mb-3 mb-sm-0">
                                <label>{{TR.key}}</label>
                                <input type="text" class="form-control" v-model="new_lang['key']" />
                            </div>
                            <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                                <label>{{TR.value}}</label>
                                <input type="text" class="form-control" v-model="new_lang['value']" />
                            </div>
                            <div class="col-12 col-sm-2 mb-3 mb-sm-0 align-self-end">
                                <button v-if="G.userHavePermission('add')" class="btn btn-primary" @click="addLanguageKeyValue(new_lang['key'], new_lang['value'])"><i class="fas fa-plus me-2"></i>{{ TR.add }}</button>
                            </div>
                        </div>
                    </fieldset>

                </div>
            </div>

            <div class="row mb-4 py-3">
                <div class="col-12 col-sm-6 offset-sm-3">
                    <!-- <input ref="searchField" type="text" class="form-control mb-3" :placeholder="TR.search" v-model="searchText" /> -->
                    <InputClear ref="searchField" class="mb-2" :placeholder="TR.search" v-model="searchText" />

                    <div v-if="searchText != '' && Object.keys(filtered).length > 0">
                        {{ Object.keys(filtered).length }} {{ TR.find_result }}
                    </div>
                </div>
            </div>
            <!-- <div class="row row-cols-1 row-cols-md-4 g-4 mt-2">
                <div class="col" v-for="( item, index ) in filtered" :key="index">
                    <div v-if="item != ''" class="card border mb-2">
                        <div class="card-header border-bottom fw-normal">Key: <b>{{ index }}</b></div>
                        <div class="card-body p-4 d-flex align-items-start">
                            <textarea type="text" class="form-control mx-2" rows="1" v-model="language[index]"></textarea>
                            <button v-if="G.userHavePermission('update')" class="btn btn-primary" @click="updateLanguageKeyValue(index, item)"><i class="fas fa-save"></i></button>
                            <button class="btn btn-danger"><i class="fas fa-trash"></i></button>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <input type="text" class="form-control mx-2" v-model="language[index]" /> -->
            <div class="row text-center fw-bold pb-4">

                <div class="col-12 col-sm-2 offset-sm-2">{{ TR.key }}</div>
                <div class="col-12 col-sm-6">{{ TR.value }}</div>
            </div>
            <div class="row mb-2" v-for="( item, index ) in filtered" :key="index">
                <template v-if="index != ''">
                    <div class="col-12 col-sm-2 offset-sm-2">{{ index }}</div>
                    <div class="col-12 col-sm-6 d-flex align-items-start">
                        <button v-if="G.userHavePermission('update')" class="btn btn-primary" @click="updateLanguageKeyValue(index, item)"><i class="fas fa-save"></i></button>
                        <textarea type="text" class="form-control mx-2" rows="1" v-model="language[index]"></textarea>
                        <button v-if="G.userHavePermission('remove')" class="btn btn-danger" @click="removeByKey(index)"><i class="fas fa-trash"></i></button>
                    </div>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from "@/system_modules/store";

    import InputClear from '@/components/field/InputClear';

    import { G, ajax } from '@/_common';

    export default {
        name: 'LanguageP',
        title: 'terms',
        components:{
            InputClear,
        },
        setup() {
            const store = useStore();

            const TR = ref({});
            const tabviewLang = ref();
            const tableData = ref([]);
            const tableOptions = ref();
            const active = ref('0');

            const searchField = ref(null);
            const selected_lang = ref('az');
            const language = ref({});
            const filtered = ref({});
            const searchText = ref('');
            const new_lang = ref({
                "key": '',
                "value": '',
            });

            watchEffect(() => {
                TR.value = store.getTranslation();
                if( searchText.value != '' ){
                    // filtered.value = Object.fromEntries(Object.entries(language.value).filter(([k,v]) => {
                    //     console.log(k, v);
                    //     return v.toString().search(searchText.value);
                    // }));
                    filtered.value = {};
                    // filtered.value = Object.keys(language.value).reduce(function (filtered1, key) {
                    //     if( language.value[key].toString().search(searchText.value) >= 0 ) filtered1[key] = language.value[key];
                    //     return filtered1;
                    // }, {});

                    Object.keys(language.value).filter((key) => {
                        // if( language.value[key].toString().match(/`${searchText.value}`/i) ) filtered.value[key] = language.value[key];
                        if( language.value[key].toString().match(new RegExp(searchText.value, 'i')) || key.match(new RegExp(searchText.value, 'i')) ){
                            filtered.value[key] = language.value[key];
                        }
                    }, {});

                }
                else{
                    filtered.value = language.value;
                }

            });

            const focusInput = () => {
                if (searchField.value) {
                    searchField.value.inputFieldRef.focus();
                }
            };

            const getAllKeyValues = async () => {
                await ajax({
                    url: store.getSettingsLang(selected_lang.value),
                    data: {},
                    success: (e) => {
                        language.value = e.data;
                    }
                });
            };

            onMounted(async () => {
                await getAllKeyValues();
                focusInput();
            });

            const addLanguageKeyValue = (key, val) => {
                if( key !== undefined && key != '' && val !== undefined && val != '' ){
                    if( language.value[key] === undefined ){
                        updateKeyValue(key, val, 'add');
                    }
                    else{
                        G.alert.warning(TR.value.already_exists);
                    }
                }
            };

            const updateLanguageKeyValue = (key, val) => {
                updateKeyValue(key, val, 'update');
            };

            const updateKeyValue = async (key, val, method) => {
                await ajax({
                    url: store.getSettingsLangUpdate(selected_lang.value),
                    method: method == 'add' ? 'post' : 'patch',
                    content_type: 'application/json; charset=UTF-8',
                    data: {
                        key_index: key,
                        key_value: val.replace('\n', '<br />')
                    },
                    success: (e) => {
                        new_lang.value = {
                            "key": '',
                            "value": '',
                        };
                        G.alert.success({toast: true, msg: e.data.detail});
                        getAllKeyValues();
                    }
                });
            }

            const removeByKey = (key) => {
                G.alert.confirm({
                    title: TR.value.warning,
                    msg: TR.value.msg_remove_question,
                    yesTitle: TR.value.yes,
                    yes: async () => {
                        ajax({
                            url: store.getSettingsLangRemove(selected_lang.value),
                            method: 'delete',
                            content_type: 'application/json; charset=UTF-8',
                            data: {
                                key_index: key
                            },
                            success: (e) => {
                                G.alert.success(e.data.detail);
                                getAllKeyValues();
                            }
                        });
                    },
                    noTitle: TR.value.no, no: () => {}
                });
            };

            return {
                G,
                TR,
                tabviewLang,
                tableData,
                tableOptions,
                language,
                searchText,
                filtered,
                addLanguageKeyValue,
                updateLanguageKeyValue,
                removeByKey,
                searchField,
                new_lang,
                selected_lang,
                active,
            };
        },
    };
</script>